define('core/RequireJsConfig',requirejs.s.contexts._.config);

